import { Link } from '@tanstack/react-router';
import { ChevronRight } from 'lucide-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { can, useMe } from '../../auth.tsx';
import { PageHeader, Panel } from '../../components/ui.tsx';
import { screensOf, visibleAreas } from '../../navigation.ts';

/** Configuração › Visão geral: o que cada parte da configuração faz, com o atalho para ela. */
export function SettingsOverviewPage() {
  const { t } = useTranslation();
  const me = useMe();
  const area = useMemo(
    () => visibleAreas((p) => can(me.data, p)).find((a) => a.id === 'settings'),
    [me.data],
  );
  const screens = area ? screensOf(area) : [];
  return (
    <>
      <PageHeader title={t('areas.settings')} description={t('settings.about')} />
      {screens.length === 0 ? (
        <Panel>
          <p className="text-sm text-muted">{t('departmentHome.noAccess')}</p>
        </Panel>
      ) : (
        <ul className="grid gap-3 lg:grid-cols-2">
          {screens.map((item) => {
            const Icon = item.icon;
            return (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="flex h-full items-start gap-4 rounded-lg border border-rule bg-sheet p-4 text-ink shadow-sm hover:border-control-border"
                >
                  <span className="flex size-10 shrink-0 items-center justify-center rounded-md bg-paper">
                    <Icon size={20} strokeWidth={1.75} aria-hidden className="text-muted" />
                  </span>
                  <span className="flex min-w-0 grow flex-col gap-0.5">
                    <span className="text-sm font-medium">{t(item.key)}</span>
                    <span className="text-sm text-muted">
                      {t(`settings.cards.${item.to.split('/').pop()}`)}
                    </span>
                  </span>
                  <ChevronRight
                    size={18}
                    strokeWidth={1.75}
                    aria-hidden
                    className="mt-0.5 shrink-0 text-control-border"
                  />
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
}
